import React from "react";
import { TableRow, TableCell, Box } from "@mui/material";
import { truncateText } from "../../../../constants";
import { stripHtml } from "../../hooks/qcGreeting";

/**
 * Row renderer for the QuickConnect templates table.
 *
 * When the org has no template of its own it inherits the shared `default`
 * document; that row is labelled so the admin understands the value is not yet
 * org-specific. Saving an edit creates the org copy.
 *
 * See docs/QUICKCOLLECT_IMPLEMENTATION.md
 */
export const QCTableRowSection = ({ row, labelId, handleRowClick }) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return "-";
    if (timestamp.seconds) {
      return new Date(timestamp.seconds * 1000).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
    return "-";
  };

  return (
    <TableRow
      hover
      tabIndex={-1}
      sx={{
        cursor: "pointer",
        "&:hover": { backgroundColor: "#f5f5f5" },
      }}
    >
      {/* Name - clickable */}
      <TableCell
        component="th"
        id={labelId}
        scope="row"
        sx={{
          fontFamily: "Avenir Book, sans-serif",
          color: "#0AB2EE",
          fontWeight: 500,
          cursor: "pointer",
          "&:hover": { textDecoration: "underline" },
        }}
        onClick={() => handleRowClick(row)}
      >
        {row.name || "QuickConnect Template"}
        {row.isDefault ? (
          <Box
            component="span"
            sx={{
              ml: 1,
              px: 1,
              py: "2px",
              borderRadius: "4px",
              fontSize: 11,
              backgroundColor: "#E8F5E9",
              color: "#2E7D32",
              fontFamily: "Avenir Book, sans-serif",
            }}
          >
            Default
          </Box>
        ) : null}
      </TableCell>

      {/* Greeting preview (HTML stripped) */}
      <TableCell
        sx={{ fontFamily: "Avenir Book, sans-serif", color: "#595959" }}
      >
        {row.greeting ? truncateText(stripHtml(row.greeting), 80) : "-"}
      </TableCell>

      {/* Updated At */}
      <TableCell
        sx={{ fontFamily: "Avenir Book, sans-serif", color: "#595959" }}
      >
        {formatDate(row.updatedAt)}
      </TableCell>

      {/* Updated By */}
      <TableCell
        sx={{ fontFamily: "Avenir Book, sans-serif", color: "#595959" }}
      >
        {row.updatedByData?.userName || row.updatedByData?.firstName || "-"}
      </TableCell>
    </TableRow>
  );
};

export default QCTableRowSection;